import { Loader } from '@googlemaps/js-api-loader'
import('../../services/google-maps-optimizer.js')

const googleMapsApi = new Loader({
  apiKey: GOOGLE_MAPS_API_KEY,
  version: '3.exp',
  libraries: ['places'],
})

googleMapsApi.load().then((google) => {
  Promise.all([import('./tab-park-info.scss'), import('../kentico-form/kentico-form')]).then(() => {
    $('.widget.tab-park-info').each(function (i, el) {
      $(el).data('widget', new TabParkInfo(el, google))
      $(el).data('widget').init()
    })
  })
})

function TabParkInfo(el, google) {
  const self = this
  self.el = $(el)
  self.formContainer = self.el.find('.form-container')
  self.optimizer = window.googleMapsOptimizer
  self.mapLoaded = false

  // Generate static map URL
  self.generateStaticMapUrl = function(lat, lng, width = 400, height = 200, zoom = 12) {
    const baseUrl = 'https://maps.googleapis.com/maps/api/staticmap'
    const params = new URLSearchParams({
      center: `${lat},${lng}`,
      zoom: zoom,
      size: `${width}x${height}`,
      scale: 2, // For retina displays
      format: 'png',
      markers: `${lat},${lng}`,
      key: GOOGLE_MAPS_API_KEY,
      style: 'feature:poi|visibility:off', // Hide points of interest for cleaner look
    })
    
    return `${baseUrl}?${params.toString()}`
  }

  // Load static map
  self.loadStaticMap = function() {
    if (self.mapLoaded) return

    const mapContainer = self.el.find('.map').get(0)
    if (!mapContainer) return

    const lat = parseFloat(mapContainer.getAttribute('data-lat'))
    const lng = parseFloat(mapContainer.getAttribute('data-lng'))
    
    if (isNaN(lat) || isNaN(lng)) {
      console.warn('Invalid coordinates for static map:', lat, lng)
      return
    }

    // Create static map image
    const img = document.createElement('img')
    const staticMapUrl = self.generateStaticMapUrl(lat, lng, 400, 200, 12)
    
    img.src = staticMapUrl
    img.alt = 'Park Location Map'
    img.style.width = '100%'
    img.style.height = '200px'
    img.style.objectFit = 'cover'
    img.style.display = 'block'

    // Add loading and error handling
    img.onload = function() {
      const mapCanvas = self.el.find('.map-canvas')
      
      if (mapCanvas.length > 0) {
        mapCanvas.empty()
        mapCanvas.append(img)
        self.mapLoaded = true
        
        // Track static map load for optimization stats
        if (self.optimizer) {
          self.optimizer.trackMapLoad()
        }
      }
    }

    img.onerror = function() {
      console.error('Static map failed to load for tab-park-info')
      // Show error message instead of fallback
      const mapCanvas = self.el.find('.map-canvas')
      mapCanvas.html(`
        <div style="
          display: flex;
          align-items: center;
          justify-content: center;
          height: 200px;
          background-color: #f5f5f5;
          border: 1px solid #ddd;
          color: #666;
          font-family: Arial, sans-serif;
        ">
          <div style="text-align: center;">
            <div style="margin-bottom: 8px;">⚠️</div>
            <div>Map unavailable</div>
          </div>
        </div>
      `)
    }

    // Add click handler to open full Google Maps
    img.onclick = function() {
      const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
      window.open(url, '_blank')
    }

    img.style.cursor = 'pointer'
    img.title = 'Click to view in Google Maps'
  }

  // Lazy loading for static maps using Intersection Observer
  self.setupStaticMapLazyLoading = function() {
    const mapContainer = self.el.find('.map').get(0)
    
    if (!mapContainer) return

    // Add loading placeholder for static map
    const mapCanvas = self.el.find('.map-canvas')
    mapCanvas.html(`
      <div class="map-loading-placeholder" style="
        display: flex;
        align-items: center;
        justify-content: center;
        height: 200px;
        background-color: #f5f5f5;
        border: 1px solid #ddd;
        color: #666;
        font-family: Arial, sans-serif;
        border-radius: 10px;
      ">
        <div style="text-align: center;">
          <div style="margin-bottom: 8px;">🗺️</div>
          <div>Map will load when visible</div>
        </div>
      </div>
    `)

    // Check if Intersection Observer is supported
    if (!('IntersectionObserver' in window)) {
      // Fallback: load static map immediately if Intersection Observer is not supported
      self.loadStaticMap()
      return
    }

    // Create Intersection Observer for static map
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !self.mapLoaded) {
          // Map container is visible, load the static map
          self.loadStaticMap()
          // Stop observing once the map is loaded
          observer.unobserve(mapContainer)
        }
      })
    }, {
      // Load static map when 10% of the container is visible
      threshold: 0.1,
      // Start loading 50px before the map enters the viewport
      rootMargin: '50px'
    })

    // Start observing the map container
    observer.observe(mapContainer)
  }

  self.bindEventHandlers = function() {
    self.el.find('.contact-park').click(function (event) {
      event.preventDefault()
      $(this).hide()

      self.formContainer.slideDown()
    })

    self.el.find('.cancel-enquiry-button').click(function (event) {
      event.preventDefault()
      self.formContainer.slideUp()
      self.el.find('.contact-park').show()
    })

    self.el.find('.contact-park-tab').click(function (event) {
      event.preventDefault()
      $(this).hide()

      self.formContainer.slideDown()
    })

    self.el.find('.tabs .tab').click(function (event) {
      event.preventDefault()

      if ($(this).hasClass('active')) {
        return
      }

      const $tab = $(this)
      const targetId = $tab.attr('href')

      self.el.find('.tabs .tab.active').removeClass('active')
      $tab.addClass('active')

      self.el.find('.content .tab-content.active').removeClass('active')
      self.el.find(targetId).addClass('active')
    })

    self.el.find('.download-link-print').click(function (event) {
      event.preventDefault()

      window.print()
    })
  }

  self.init = function () {
    self.el.css('opacity', 1)
    
    // Always use static maps with lazy loading for tab-park-info
    self.setupStaticMapLazyLoading()

    // Initialize form data if available
    if (self.formContainer.attr('data-park-form-recipient')) {
      self.formContainer.find('input[type=hidden]').each(function () {
        if ($(this).attr('name').indexOf('Recipient.Value') > -1) {
          $(this).val(self.formContainer.attr('data-park-form-recipient'))
          return false
        }
      })
    }

    if (self.formContainer.attr('data-park-form-title')) {
      self.formContainer.find('input[type=hidden]').each(function () {
        if ($(this).attr('name').indexOf('ParkTitle.Value') > -1) {
          $(this).val(self.formContainer.attr('data-park-form-title'))
          return false
        }
      })
    }

    // Initialize contact accordion
    self.el.find('.contact-accordion .header').click(function (event) {
      event.preventDefault()

      self.el.find('.contact-accordion').toggleClass('expanded')

      if (self.el.find('.contact-accordion').hasClass('expanded')) {
        $(this).parents('.contact-accordion').find('.content').slideDown()
      } else {
        $(this).parents('.contact-accordion').find('.content').slideUp()
      }
    })

    self.bindEventHandlers()
  }
}
